import Vue from 'vue';
import VueNumeralFilterInstaller from 'vue-numeral-filter';

Vue.use(VueNumeralFilterInstaller);
